var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 38,
    viewBox: "0 0 63 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2553 24.1142C29.1656 24.117 27.14 23.3918 25.5258 22.0628L23.858 20.6889L1.91895 38H60.3266L38.523 20.7959L36.9877 22.0628C35.3726 23.3922 33.3459 24.1175 31.2553 24.1142Z",
    fill: "#00B2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00244141 1.03477V1.54807C0.00244141 1.84622 0.00244141 2.77283 0.00244141 3.06806V36.3549L21.9012 19.076L0.00244141 1.03477Z",
    fill: "#00B2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4795 19.1836L62.9475 36.912C62.9864 30.9252 63.0035 24.9383 62.9988 18.9515V0.629044L40.4795 19.1836Z",
    fill: "#00B2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4483 20.1914L59.9552 0H2.55518L27.0639 20.1914C28.2462 21.1618 29.7275 21.692 31.2561 21.692C32.7846 21.692 34.266 21.1618 35.4483 20.1914Z",
    fill: "#00B2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.07591f1779c4ba297bc9295159037b80.svg";
export { ForwardRef as ReactComponent };